import axios, {AxiosResponse, AxiosError} from 'axios';
import Vue from "vue";

// Create Bus for communications
window.Bus = new Vue();

const element = document.querySelector('meta[name="csrf-token"]');

let token = null;

if (element) {
    token = element.getAttribute('content');
    localStorage.setItem('CSRFToken', token);
}

const instance = axios.create({
    baseURL: '/'
});

instance.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': token ? token : ''
};

instance.interceptors.response.use(function (response) {

    return response;

}, function (error) {

    if (error.response) {

        switch (error.response.status) {

            case 401: // Unauthorized
                Bus.$emit('show-session-expired');
                break;

            case 402:
                Bus.$emit('show-trial-expired');
                break;

            case 419: // Session expired
                Bus.$emit('show-session-expired');
                break;

            case 429:
                Bus.$emit('flash-message', {
                    message: 'Too many requests! Please wait before trying again.',
                    type: 'error',
                    duration: 8000
                });
                break;

            case 500:
                Bus.$emit('flash-message', {
                    message: 'Oops! Something went wrong on our side. Please try again later.',
                    type: 'error',
                    duration: 8000
                });
                break;
        }
    } else {
        console.error(error)
    }

    return Promise.reject(error);
});

instance.interceptors.request.use(function (config) {

    const token = localStorage.getItem('CSRFToken');

    if (token) {
        config.headers['X-CSRF-TOKEN'] = token;
    }

    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

export default instance;

